import React, { Suspense, useState } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { RoutesPage, RoutesAuth, RoutesUser, RoutesRevamp, preloadDashboardRoutes } from "../Route/route";
import RevampShell from "../revamp/layout/RevampShell";
import LegacyShell from "../revamp/layout/LegacyShell";
import { LIVE_ROUTES } from "../revamp/lib/routes";

// import UserHeader from "../Component/UserHeader";  // replaced by the revamp AppHeader
import AppHeader from "../revamp/layout/AppHeader";
import NotFound from "../Component/NotFound";
import Loading from "../Component/Loader";
import { useEffect } from "react";
import { agent } from "../utils/agent";
import * as API from "../utils/apiPath";

// The design's own addresses (/find-a-mentor, /for-organisations, /mentorlookup, ...)
// redirect to the live ones, so links from the design review site keep working.
const DESIGN_ADDRESS_REDIRECTS = Object.entries(LIVE_ROUTES).filter(
  ([from, to]) => from !== to && !from.includes("#")
);

const RouteWithHeader = ({ component: Component, ...rest }) => {
  const url = window.location.href.toLowerCase();
  const contains = ['!', '!#', '#', '#!'].some((char) => url.includes(char));
  const newUrl = url.replace('#', '').replace('!', '').replace('!#', '').replace('#!', '');
  useEffect(() => {
    if (window.location.search.includes('?_escaped_fragment_')) {
      const updatedSearch = window.location.search.replace('?_escaped_fragment_', '');

      const updatedURL = `${window.location.origin}${window.location.pathname}${updatedSearch}${window.location.hash}`;

      window.history.replaceState(null, null, updatedURL);
    }
    if (contains) {
      window.history.replaceState(null, null, newUrl)
    }
  }, []);

  // Partner mentor pages render without any header/footer (unchanged behaviour).
  const substrings = ['mahadewi-mentoring', 'scs-wit-mentoring'];
  const result = substrings.some(substring => url?.includes(substring));
  return (
    <Route
      {...rest}
      render={(props) =>
        result ? (
          <Suspense fallback={<Loading />}>
            <Component {...props} title={rest.title} />
          </Suspense>
        ) : (
          // 5th Anniversary revamp: old page content between the NEW header and footer
          <LegacyShell>
            <Suspense fallback={<Loading />}>
              <Component {...props} title={rest.title} />
            </Suspense>
          </LegacyShell>
        )
      }
    />
  );
};

// 5th Anniversary revamp: page inside the new shell (its own header/footer).
const RouteWithRevampShell = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => (
      <RevampShell>
        <Suspense fallback={<Loading />}>
          <Component {...props} title={rest.title} />
        </Suspense>
      </RevampShell>
    )}
  />
);

// 5th Anniversary revamp (plan task 21): these auth screens get the new header/footer
// and the restyle in src/revamp/styles/auth-restyle.css. In-app webviews
// (aboutusapp, faqapp, ...) keep rendering bare, as before.
const AUTH_PATHS_IN_NEW_SHELL = [
  "/login",
  "/register",
  "/forgotPassword",
  "/forgot-password",
  "/reset-password",
  "/mentee-signup-step-1",
  "/mentee-signup-step-2",
  "/mentee-signup-step-3",
  "/mentee-signup-step-4",
];

const RouteWithAuth = ({ component: Component, ...rest }) => {
  const inNewShell = AUTH_PATHS_IN_NEW_SHELL.includes(rest.path);
  const url = window.location.href;
  const contains = ['!', '!#', '#', '#!'].some((char) => url.includes(char));
  const newUrl = url.replace('#', '').replace('!', '').replace('!#', '').replace('#!', '');
  useEffect(() => {
    if (window.location.search.includes('?_escaped_fragment_')) {
      const updatedSearch = window.location.search.replace('?_escaped_fragment_', '');

      const updatedURL = `${window.location.origin}${window.location.pathname}${updatedSearch}${window.location.hash}`;

      window.history.replaceState(null, null, updatedURL);
    }
    if (contains) {
      window.history.replaceState(null, null, newUrl)
    }
  }, []);
  return (
    <Route
      {...rest}
      render={(props) =>
        inNewShell ? (
          <LegacyShell>
            <div className="vl-auth-page">
              <Suspense fallback={<Loading />}>
                <Component {...props} title={rest.title} />
              </Suspense>
            </div>
          </LegacyShell>
        ) : (
          <Suspense fallback={<Loading />}>
            <Component {...props} title={rest.title} />
          </Suspense>
        )
      }
    />
  );
};

const RouteWithSidebar = ({ component: Component, ...rest }) => {
  const url = window.location.href;
  const contains = ['!', '!#', '#', '#!'].some((char) => url.includes(char));
  const newUrl = url.replace('#', '').replace('!', '').replace('!#', '').replace('#!', '');
  useEffect(() => {
    preloadDashboardRoutes();
    if (window.location.search.includes('?_escaped_fragment_')) {
      const updatedSearch = window.location.search.replace('?_escaped_fragment_', '');

      const updatedURL = `${window.location.origin}${window.location.pathname}${updatedSearch}${window.location.hash}`;

      window.history.replaceState(null, null, updatedURL);
    }
    if (contains) {
      window.history.replaceState(null, null, newUrl)
    }
  }, []);
  return (
    <Route
      {...rest}
      render={(props) => (
        // 5th Anniversary revamp: new header on top, new fonts/colours via
        // src/revamp/styles/app-ui.css.
        <div className="main-body vl-app">
          <div className="page-wrapper">
            <AppHeader />
            <Suspense fallback={<Loading />}>
              <Component {...props} title={rest.title} />
            </Suspense>
          </div>
        </div>
      )}
    />
  );
};

const Index = (props) => {
  const [showMarqueeState, setShowMarqueeState] = useState(false);

  //   const {
  //   setting: { module_data },
  // } = props;

  console.log('props', props)


  const [settings, setSettings] = useState({
    start_date_time: null,
    end_date_time: null,
    notification_message: "",
    site_maintenance_mode: false,
    site_maintenance_message: "",
    site_maintenance_notification: false,
  });

  useEffect(() => {
    // const url =
    //   process.env.REACT_APP_API_BASE_URL + API.GET_MAINTAINENCE_SETTING;
    agent
      .get(API.GET_MAINTAINENCE_SETTING)
      .then((response) => {
        const data = response.data?.data || {};
        console.log("data in setting api:", data);
        setSettings({
          start_date_time: data.start_date_time,
          end_date_time: data.end_date_time,
          notification_message: data.notification_message,
          site_maintenance_mode: data.site_maintenance_mode,
          site_maintenance_message: data.site_maintenance_message,
          site_maintenance_notification: data.site_maintenance_notification,
        });
      })
      .catch((error) => {
        console.error("Error fetching settings:", error);
      });
  }, []);

const showMarquee = () => {
  if (settings.site_maintenance_notification != 1) return false;

  const now = new Date();
  const from = new Date(settings.start_date_time);
  const to = new Date(settings.end_date_time);

  return now >= from && now <= to && !!settings.notification_message;
};

  useEffect(() => {
    console.log("Updating marquee state based on settings", showMarquee());
    setShowMarqueeState(showMarquee());
  }, [settings]);

  return (
    <>
    {showMarqueeState && (
        <div className="marquee-wrapper">
          <div
            style={{
              background: "#f0f8ff",
              whiteSpace: "nowrap",
              overflow: "hidden",
              fontWeight: "bold",
              padding: "10px",
              color: "#000"
            }}
          >
            {console.log("fffffffffffff")}
            <div
            className="marquee-text"
            >
              {settings.notification_message}
            </div>
            <style>{`
            @keyframes marquee {
              0% { transform: translateX(100%) }
              100% { transform: translateX(-100%) }
            }
          `}</style>
          </div>
        </div>
      )}
    <Suspense fallback={<Loading />}>
    <Switch>
      {DESIGN_ADDRESS_REDIRECTS.map(([from, to]) => (
        <Redirect key={"redirect-" + from} exact from={from} to={to} />
      ))}
      {RoutesRevamp.map((route, index) => (
        <RouteWithRevampShell
          key={"revamp-" + index}
          exact
          path={route.path}
          component={route.component}
          title={route.title}
        />
      ))}
      {RoutesPage.map((route, index) => (
        <RouteWithHeader
          key={index}
          exact
          path={route.path}
          component={route.component}
          title={route.title}
        />
      ))}
      {RoutesAuth.map((route, index) => (
        <RouteWithAuth
          key={index}
          exact
          path={route.path}
          component={route.component}
          title={route.title}
        />
      ))}
      {RoutesUser.map((route, index) => (
        <RouteWithSidebar
          key={index}
          exact
          path={route.path}
          component={route.component}
          title={route.title}
        />
      ))}
      <RouteWithHeader
        key={''}
        exact
        path={'*'}
        component={NotFound}
        title={'Not Found'}
      />
    </Switch>
    </Suspense>
    </>

  );
};

export default Index;
